__turbopack_context__.v({
  "button": "JzTSBG_button",
  "buttonText": "JzTSBG_buttonText",
  "description": "JzTSBG_description",
  "disabled": "JzTSBG_disabled",
  "form": "JzTSBG_form",
  "input": "JzTSBG_input",
  "root": "JzTSBG_root",
});
